// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__ejdzY","inputWrap":"styles_inputWrap__3STY1","input":"styles_input__1Db34"};